module.exports = __webpack_public_path__ + "img/Arquivo.cc715e2f.svg";